import { get, put } from "@sal/webrequest-web";
import { assertApiSuccess } from "code/apiError";
import { CompanyDetails } from "models/CompanyDetails";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

const options = {
	revalidateIfStale: false,
	revalidateOnFocus: false,
	revalidateOnReconnect: false
};

const fetcher = async (url: string) =>
	assertApiSuccess<CompanyDetails>(await get(url), "Failed to load company details.");

const updateCompanyDetailsFetcher = async (
	url: string,
	{ arg }: { arg: { email: string; phone: string } }
) => assertApiSuccess<CompanyDetails>(await put(url, arg), "Failed to update company details.");

export function useGetCompanyDetails() {
	const {
		data,
		isLoading,
		error,
		mutate: mutateData
	} = useSWR<CompanyDetails>("api/CompanyDetails", fetcher, options);

	return { data, isDataLoading: isLoading, dataError: error, mutateData };
}

export function useUpdateCompanyDetails() {
	const { trigger, isMutating: isUpdating } = useSWRMutation(
		"api/CompanyDetails",
		updateCompanyDetailsFetcher
	);

	return { updateCompanyDetails: trigger, isUpdating };
}
